import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import AdminLayout from "../admin/layout";
import AuthorityLayout from "../authority/AuthorityLayout";
import FrontLayout from "./frontLayout";
import { useUserType } from "../../constants/useRoles";

const LayoutDecider = () => {
  const { user } = useSelector((state) => state.auth);
  const { isAdmin, isAuthority, isAuthorityUser } = useUserType();

  if (!user?.access_token) {
    return <Navigate to="/login" replace />;
  }
  if (isAdmin) return <AdminLayout />;
  if (isAuthority || isAuthorityUser) {
    return <AuthorityLayout />;
  }
  return <FrontLayout />;
};

export default LayoutDecider;
